(function () {
    'use strict';

    angular.module("imApp").factory("consignmentShipmentsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1101,
                    parameters: parms || {}
                });
            },
            listShipments: function (parms) {
                return $ihttp.post({
                    method: 1102,
                    parameters: parms || {}
                });
            },
            changeBusiness: function (edit) {
                return $ihttp.post({
                    method: 1103,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
